export default __webpack_public_path__ + "static/media/connect-devices.cf042c67.png";